import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export default function ProductCardTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h3
      className={cn("truncate overflow-ellipsis whitespace-nowrap", className)}
    >
      {children}
    </h3>
  );
}

ProductCardTitle.displayName = "ProductCardTitle";
